import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  filter: {
    marginLeft: theme.spacing(2),
  },
}));

export default useStyles;
